import {
  Base
} from '../Base';
export class BatchDetails extends Base {
  batchid ? : number=0; //batchid
  isActiveFlag ? : boolean=true; //isactiveflag
  BatchName ? : string=null;//batchname
  ticketCount ? : number=0; //ticketcount
  effectiveDate ? : string=null; //effectivedate
  expirationDate ? : string=null; //expirationdate
  batchdescription ? : string=null; 
  equipmentsubtypeid?: number=0;
  equipmenttypeid ? : number=0;  
  findings ?: string=null;
  manufacturerid ? : number=0;
  modelid ? : number=0;
  payrollcodeid ?: number=0; 
  sqacodeid ?: number=0;
  sqasubcodeid ?: number=0;
  servicerequested ?: string=null;
  workperformed? : string=null;
  worktypeid ?: number=0;

}
export class BatchInfoResponse extends Base {
  response ? : Array < BatchDetails > ;
  constructor() {
    super();
  }
}

export class BatchSelectedData {

  batchid ? : number;
  isActiveFlag ? : number;
  BatchName ? : string;
  ticketCount ? : number;
  effectiveDate ? : string;
  expirationDate ? : string;
  batchdescription ? : string;
  sqacodeid ?: number;
  sqasubcodeid ?: number;
  worktypeid ?: number;
  payrollcodeid ?: number;
  equipmentsubtypeid?: number;
  equipmenttypeid ? : number;  
  manufacturerId ?: number;
  ModelId ? : number;
  servicerequested ?: string;
  findings ?: string;
  workperformed? : string;

  countBatchPart ?: number=0;
  countDiscreteMeasures? : number=0;

}
export class DiscreteMeasures{
  discretemeasureattributedesc ? : string;
  discretemeasureattributeid ? : number;
  discretemeasuretypedesc ? : string;
  discretemeasuretypeid ? : number;
}
export class AdminBatchMeasure {
  batchId?: number;
  discreteMeasureId?: number;
  discreteMeasureAttributeId?: number;
  discreteMeasureTypeId?: number;
  MinValue?: any;
  MaxValue?: any;
  minDate1?: any;
  maxDate1?: any;
  answer?: number;
  discreteMeasureTypeDesc?: string;
  discreteMeasureAttributeDesc?: string;
}
export class AdminBatchPart {
  batchPartId?: number;
  batchId?: number;
  SelectedPartId?: number;
  PartQuantity?: number;
  partDescription?: string;
  partNumber?: string;
  unitCost?: number;
  manufacturerName?: string;
}

